<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PKDE7j/tc-custom/9781452148762.jpg?1740427081544" alt="This image is the cover for the book Small Victories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Small Victories
      </h1>
      <p class="bookDescription body article font2">
        <b>The acclaimed cookbook author reveals the secrets to great home cooking with this cookbook featuring kitchen tips and 400+ simple recipes and variations.</b><br/>  <br/> Go-to recipe developer Julia Turshen is the co-author of best-selling cookbooks such as Gwyneth Paltrow’s <i>It</i><i>’</i><i>s All Good</i>, and Dana Cowin’s <i>Mastering My Mistakes in the Kitchen</i>, as well as the author of her own cookbooks <i>Now &amp; Again</i> and <i>Feed the Resistance</i>. In <i>Small Victories</i>, she shares a treasure trove of kitchen tips and simple recipes you’ll return to again and again.<br/>  <br/> Julia demystifies the process of home cooking through more than a hundred “small victories”—funny and inspiring lessons she has learned through a lifetime of cooking thousands of meals. This beautifully curated, deeply personal collection emphasizes bold-flavored, honest food for breakfast, lunch, dinner, and dessert. The volume is enhanced by more than 160 mouth-watering photographs from acclaimed photographers Gentl + Hyers to follow while cooking. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julia Turshen, Ina Garten
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f7f70616